/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { PortableText } from '@portabletext/react';
import { graphql } from 'gatsby';
import React from 'react';
import { getComponents } from '../../portableText';
import { BackgroundColorTheme } from '../../templates/Page';
import { RawPortableText } from '../../types/types';
import { clsx } from '../../utils/utils';
import * as styles from './Hero.module.scss';
import ModuleLayout from './ModuleLayout';

export const query = graphql`
  fragment Hero on SanityHero {
    title {
      ...LocaleStringFragment
    }
    text {
      ...LocaleParagraphPortableText
    }
  }
`;

export type HeroType = {
  title: string;
  text?: RawPortableText;
  children?: React.ReactNode;
};

type HeroProps = HeroType & {
  theme?: BackgroundColorTheme;
  subtitle?: JSX.Element;
  className?: string;
};

const Hero = ({ title, subtitle, text, theme, children }: HeroProps): React.ReactElement => {
  return (
    <ModuleLayout
      className={clsx(styles.container, styles.onlyText)}
      contentClassName={clsx(styles.contentContainer)}
      currentModuleBgColor={theme}
    >
      <div className={clsx(styles.contentWrapper)}>
        <div className={styles.textContainer}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          {text && (
            <div className={styles.text}>
              <PortableText value={text} components={getComponents()} />
            </div>
          )}
          {children && <div className={styles.children}>{children}</div>}
        </div>
      </div>
    </ModuleLayout>
  );
};

export default Hero;
